<div class="d-flex flex-column justify-center align-center h-100">
  <div class="mb-5">
    <v-img src="@/assets/images/logo_wide_2025.png" width="200" />
  </div>
  <div class="text-secondary text-h6">¡Muchas gracias por este año 2024!</div>
  <div>Nuestra plataforma de Donaciones se encuentra en mantenimiento, pronto volveremos.</div>
</div>